import { i18nFilter } from "app/filters/i18nFilter";
import {
    Separator,
    Title,
} from "app/pages/website-analysis/audience-interests/single/AudienceInterestsTableTop/AudienceInterestsTableTopStyles";
import { PrimaryBoxTitle } from "pro-features/styled components/StyledBoxTitle/src/StyledBoxTitle";
import type { FC } from "react";

interface IHeader {
    titleKey: string;
    tooltipKey: string;
}

export const Header: FC<IHeader> = (props) => {
    const { titleKey, tooltipKey } = props;
    const i18n = i18nFilter();
    return (
        <>
            <Title>
                <PrimaryBoxTitle tooltip={i18n(tooltipKey)}>{i18n(titleKey)}</PrimaryBoxTitle>
            </Title>
            <Separator />
        </>
    );
};
